import React, {useMemo} from "react";
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import {useTranslation} from "react-i18next";
interface InputTextProps {
    value: null | string;
    placeholder: null | string;
    onChange: (value: string) => void;
    className: null | string;
    inputClassName: null | string;
}
const InputPhone= ({ placeholder, value, onChange, className, inputClassName}: InputTextProps) => {

    const { i18n } = useTranslation();

    const currentLanguage = useMemo(() => {
        const lang = i18n.language;
        if (!lang || lang === 'en') return 'gb';
        if (lang === 'ka') return 'ge';
        return lang;
    }, [i18n.language]);

    const inputValue = value?.toString() ?? '';
    const hasValue = inputValue.length > 0;

    if (!currentLanguage && !hasValue) {
        return null;
    }

    return (
        <PhoneInput
            className={className || undefined}
            placeholder={placeholder || ""}
            {...(!hasValue ? { defaultCountry: currentLanguage } : {})}
            disableDialCodePrefill={true}
            value={inputValue}
            inputClassName={inputClassName || undefined}
            onChange={onChange}
        />
    );
};
export default InputPhone;
